var $4f59066070e984ad$exports = {};
$4f59066070e984ad$exports = {
    "(optional)": `(optional)`,
    "(required)": `(erforderlich)`
};


export {$4f59066070e984ad$exports as default};
//# sourceMappingURL=de-DE.mjs.map
